import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { ATOM_KEY } from "../keys";

const bookingEngineAtom = atom<string>({
    key: ATOM_KEY.BOOKING_ENGINE,
    default: "",
});

export const useBookingRecoilState = () => useRecoilState(bookingEngineAtom);
export const useSetBookingRecoilState = () => useSetRecoilState(bookingEngineAtom);
export const useBookingRecoilValue = () => useRecoilValue(bookingEngineAtom);

const bookingYeogiAtom = atom<string>({
    key: `${ATOM_KEY.BOOKING_ENGINE}_YEOGI`,
    default: "",
});

export const useBookingYeogiRecoilState = () => useRecoilState(bookingYeogiAtom);
export const useSetBookingYeogiRecoilState = () => useSetRecoilState(bookingYeogiAtom);
export const useBookingYeogiRecoilValue = () => useRecoilValue(bookingYeogiAtom);
